import React from 'react';
import {Routes, Route} from 'react-router-dom';
import Home from '../pages/Home';
import Main from './Main';
import Appointment from '../pages/Appoinment';
import Services from '../pages/Services';
import Auto from './inquiries/Auto';
import Residential from '../pages/Residential';
import Commercial from '../pages/Commercial';
import VinLookup from './vinlookup';
import ServiceHome from '../pages/ServiceHome';
import Contact from '../pages/Contact';
import FAQ from '../pages/Faq';
import NotFoundPage from './404';

const AppRoutes = () => {
    return (
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route index="index" element={<Home />}/>
                    <Route path="appointment" element={<Appointment />}/>
                    <Route path="contact" element={<Contact/>}/>
                    <Route path="services" element={<Services />}>
                    <Route path="service_home" element={<ServiceHome/>}/>
                        <Route path="auto" element={<Auto />}/>
                        <Route path="residential" element={<Residential />}/>
                        <Route path="commercial" element={<Commercial/>}/>
                        <Route path="vin" element={<VinLookup/>}/>
                    </Route>
                    <Route path="*" element={<NotFoundPage/>}/>
                    <Route path="faq" element={<FAQ/>}/>
                </Route>
            </Routes>
    );
};

export default AppRoutes;
